import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

import { LearningFacadeService, GroupedSpecialization } from '../../../services/learning-facade.service';

@Component({
  selector: 'app-learning-tree-container',
  templateUrl: './learning-tree-container.component.html',
  styleUrls: ['./learning-tree-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningTreeContainerComponent implements OnInit, OnDestroy {

  groupedSpecializations: GroupedSpecialization[] = [];
  isLoading: boolean = true;
  hasError: boolean = false;

  private destroy$ = new Subject<void>();

  constructor(
    private facade: LearningFacadeService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadSpecializations();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSpecializationSelected(specId: string): void {
    this.router.navigate(['/dashboard/learning', specId]);
  }

  private loadSpecializations(): void {
    this.isLoading = true;
    this.hasError = false;
    this.cdr.markForCheck();

    this.facade.fetchSpecializationsGrouped()
      .takeUntil(this.destroy$)
      .subscribe(
        groups => {
          this.groupedSpecializations = groups;
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        () => {
          this.hasError = true;
          this.isLoading = false;
          this.cdr.markForCheck();
        },
      );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/user/learning-tree/learning-tree-container.component.ts